import { Platform } from './platform';
import { Stage } from './stage';

export enum RBITokenType {
  unverified = 'unverified',
  verified = 'verified',
}

export interface IRBIToken {
  exp: number;
  iat: number;
  platform: Platform;
  stage: Stage;
  sub: string;
  type?: RBITokenType;
}

export interface IRBICateringToken {
  exp: number;
  iat: number;
  stage: Stage;
  sub: string;
}
